/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppPlaybookRouteImport } from './routes/_app/playbook'
import { Route as AppSettingsUsersRouteImport } from './routes/_app/settings/users'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppPlaybookRoute = AppPlaybookRouteImport.update({
  id: '/playbook',
  path: '/playbook',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsUsersRoute = AppSettingsUsersRouteImport.update({
  id: '/settings/users',
  path: '/settings/users',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/login': typeof LoginRoute
  '/playbook': typeof AppPlaybookRoute
  '/settings/users': typeof AppSettingsUsersRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/login': typeof LoginRoute
  '/playbook': typeof AppPlaybookRoute
  '/settings/users': typeof AppSettingsUsersRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/callback': typeof CallbackRoute
  '/login': typeof LoginRoute
  '/_app/playbook': typeof AppPlaybookRoute
  '/_app/settings/users': typeof AppSettingsUsersRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/callback' | '/login' | '/playbook' | '/settings/users'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/callback' | '/login' | '/playbook' | '/settings/users'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/callback'
    | '/login'
    | '/_app/playbook'
    | '/_app/settings/users'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  CallbackRoute: typeof CallbackRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/playbook': {
      id: '/_app/playbook'
      path: '/playbook'
      fullPath: '/playbook'
      preLoaderRoute: typeof AppPlaybookRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/users': {
      id: '/_app/settings/users'
      path: '/settings/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AppSettingsUsersRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppPlaybookRoute: typeof AppPlaybookRoute
  AppSettingsUsersRoute: typeof AppSettingsUsersRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppPlaybookRoute: AppPlaybookRoute,
  AppSettingsUsersRoute: AppSettingsUsersRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  CallbackRoute: CallbackRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
